import AnimatedRoute from '../AnimatedRoute';

const PublicRoutes = () => {
  return <AnimatedRoute />;
};
export default PublicRoutes;
